<div class="button {{type}}">
    <app-icon-button *ngIf="isIconEnabled" [iconButtonType]="iconType" class="button__icon"></app-icon-button>
    <div class="button__text">{{text}}</div>
</div>